import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, CheckCircle2, ArrowRight } from "lucide-react";
import api, { formatApiError, TOKEN_KEY } from "@/lib/api";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function SetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [state, setState] = useState("checking"); // checking | valid | invalid
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    api.post("/auth/validate-token", { token })
      .then((r) => { if (r.data.valid) { setInfo(r.data); setState("valid"); } else setState("invalid"); })
      .catch(() => setState("invalid"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Şifre en az 6 karakter olmalı.");
    if (pw !== pw2) return toast.error("Şifreler eşleşmiyor.");
    setSaving(true);
    try {
      const r = await api.post("/auth/set-password", { token, password: pw });
      localStorage.setItem(TOKEN_KEY, r.data.token);
      toast.success("Şifren belirlendi, giriş yapılıyor...");
      window.location.href = "/";
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0E] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center"><Logo /></div>
        {state === "checking" && <div className="flex justify-center"><Loader2 className="animate-spin text-[#FF5500]" size={28} /></div>}
        {state === "invalid" && (
          <div className="text-center" data-testid="set-password-invalid">
            <h2 className="font-display font-extrabold text-2xl text-white">Bağlantı geçersiz</h2>
            <p className="text-sm text-[#A0A0B2] mt-2">Bu davet/sıfırlama bağlantısı geçersiz ya da süresi dolmuş.</p>
            <Link to="/login" className="inline-flex items-center gap-1 text-[#FF5500] font-semibold mt-4">Girişe dön <ArrowRight size={16} /></Link>
          </div>
        )}
        {state === "valid" && (
          <form onSubmit={submit} data-testid="set-password-form">
            <div className="flex items-center gap-2 mb-1 text-[#10B981]"><CheckCircle2 size={16} /><span className="text-xs font-semibold uppercase tracking-wide">Hesap Doğrulandı</span></div>
            <h2 className="font-display font-extrabold text-2xl text-white">Şifreni Belirle</h2>
            <p className="text-sm text-[#A0A0B2] mt-1 mb-6">{info?.email} için yeni bir şifre oluştur.</p>
            <div className="space-y-4">
              <div><label className="text-xs text-[#A0A0B2] mb-1.5 block">Yeni Şifre</label>
                <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" placeholder="En az 6 karakter" className="bg-[#0E0E14] border-[#262636] h-11 text-white focus-visible:ring-[#FF5500]" /></div>
              <div><label className="text-xs text-[#A0A0B2] mb-1.5 block">Şifre (Tekrar)</label>
                <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="set-password-confirm" className="bg-[#0E0E14] border-[#262636] h-11 text-white focus-visible:ring-[#FF5500]" /></div>
              <Button type="submit" disabled={saving} data-testid="set-password-submit" className="w-full h-11 bg-[#FF5500] hover:bg-[#FF661A] text-white font-bold rounded-xl">
                {saving ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} className="mr-1" /> Şifreyi Kaydet</>}
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
